import RouteContainer from 'containers/RouteContainer';
import InstallIcons from './components/InstallIcons';

export const path = APP_ICONS_PATH;

export default RouteContainer(path, InstallIcons, { exact: true });
